import { EditableField } from '../../../../commonComponents/EditableField';

export const SummaryField = ({ summary, summaryForm, isEditing, onChange }) => (
  <EditableField
    editing={isEditing}
    view={
      <span className="f-16 mt-3" style={{ fontStyle: 'italic' }}>
        {summary ? `“${summary}”` : '-'}
      </span>
    }
    edit={
      <div className="mt-3">
        <span className="f-13">240 Character Limit</span>
        <textarea
          className="form-control mt-2"
          style={{ height: 92, paddingBlock: 10 }}
          maxLength={240}
          value={summaryForm || ''}
          onChange={(e) => onChange('summary', e.target.value)}
        />
      </div>
    }
  />
);
